import { Navigate } from "react-router-dom";

const Notefound = () => {
  return <Navigate to="/" replace />;
};

export default Notefound;
